import { Route, Routes } from "react-router-dom";
import { Page404 } from "../pages/Page404";
import { Inicio } from "../pages/inicio/Inicio";
import { Login } from "../pages/Login";
import { EstudiantePage } from "../pages/adm/estudiante/EstudiantePage";
import { RegistrarEstudiantePage } from "../pages/adm/estudiante/RegistrarEstudiantePage";
import { RegistroMasivoEstudiantesPage } from "../pages/adm/estudiante/RegistroMasivoEstudiantesPage";
import { ActualizarEstudiantePage } from "../pages/adm/estudiante/ActualizarEstudiantePage";
import { CambiarContrasenaPage } from "../pages/CambiarContrasenaPage";
import { PrivateRoutes } from "./PrivateRoutes";
import { IdiomaPage } from "../pages/adm/idioma/IdiomaPage";
import { RegistrarIdiomaPage } from "../pages/adm/idioma/RegistrarIdiomaPage";
import { DocentePage } from "../pages/adm/docente/DocentePage";
import { RegistrarDocentePage } from "../pages/adm/docente/RegistrarDocentePage";
import { ProgramaPage } from "../pages/adm/programa/ProgramaPage";
import { RegistrarProgramaPage } from "../pages/adm/programa/RegistrarProgramaPage";
import { RegistrarGrupoPage } from "../pages/adm/grupo/RegistrarGrupoPage";
import { GrupoPage } from "../pages/adm/grupo/GrupoPage";
import { GruposActivosPage } from "../pages/adm/grupo/GruposActivosPage";
import { TurnoPage } from "../pages/adm/turno/TurnoPage";
import { ModalidadPage } from "../pages/adm/modalidad/ModalidadPage";
import { HorarioPage } from "../pages/adm/horario/HorarioPage";
import { RegistrarHorarioPage } from "../pages/adm/horario/RegistrarHorarioPage";
import { RegistrarModuloPage } from "../pages/adm/modulo/RegistrarModuloPage";
import { IdiomaDetalle } from "../pages/adm/idioma/IdiomaDetalle";
import { RegistroEstudiantePage } from "../pages/est/registro/RegistroEstudiantePage";
import { RegistroEstudianteDetalle } from "../pages/est/registro/RegistroEstudianteDetalle";
import { HistorialNotasPage } from "../pages/est/historial/HistorialNotasPage";
import { MisLogrosPage } from "../pages/est/logros/MisLogrosPage";
import { GrupoDocentePage } from "../pages/doc/grupo/GrupoDocentePage";
import { HistorialGrupoDocentePage } from "../pages/doc/grupo/HistorialGrupoDocentePage";
import { GrupoDocenteDetalle } from "../pages/doc/grupo/GrupoDocenteDetalle";
import { AsignarModuloEstudiantePage } from "../pages/adm/registro/AsignarModuloEstudiantePage";
import { RecursoEducativo } from "../pages/RecursoEducativo";
import { ActualizarDocentePage } from "../pages/adm/docente/ActualizarDocentePage";
import { ActualizarProgramaPage } from "../pages/adm/programa/ActualizarProgramaPage";
import { GestionarIdiomasProgramaPage } from "../pages/adm/programa/GestionarIdiomasProgramaPage";
import { ActualizarIdiomaPage } from "../pages/adm/idioma/ActualizarIdiomaPage";
import { ActualizarGrupoPage } from "../pages/adm/grupo/ActualizarGrupoPage";
import { CongeladosPage } from "../pages/adm/estudiante/CongeladosPage";
import { EstudiantesReprobadosPage } from "../pages/adm/estudiante/EstudiantesReprobadosPage";
import EstudiantesActivos from "../pages/adm/estudiante/EstudiantesActivos";
import { UnirGruposPage } from "../pages/adm/grupo/UnirGruposPage";
import { EstudiantesGrupoPage } from "../pages/adm/grupo/EstudiantesGrupoPage";
import DescongelarEstudiantesPage from "../pages/adm/estudiante/DescongelarEstudiantesPage";
import AsistenciaPage from "../pages/doc/asistencia/AsistenciaPage";
import { AsignarModuloEstudianteDesCongelarPage } from "../pages/adm/registro/AsignarModuloEstudianteDesCongelarPage";
import { ActualizarHorarioPage } from "../pages/adm/horario/ActualizarHorarioPage";
import { ModuloPage } from "../pages/adm/modulo/ModuloPage";
import { ActualizarModulo } from "../pages/adm/modulo/ActualizarModuloPage";
import { PerfilEstudiantePage } from "../pages/est/perfil/PerfilEstudiantePage";
import { PlazoNotas } from "../pages/adm/docente/PlazoNotas";
import { EditarPerfilEstudiantePage } from "../pages/est/perfil/EditarPerfilEstudiantePage";
import { PerfilAdmPage } from "../pages/adm/perfil/PerfilAdmPage";
import { EditarPerfilAdmPage } from "../pages/adm/perfil/EditarPerfilAdmPage";
import { EditarPerfilDocentePage } from "../pages/doc/perfil/EditarPerfilDocentePage";
import { PerfilDocentePage } from "../pages/doc/perfil/PerfilDocentePage";
import { NotificacionesPage } from "../pages/adm/notificacion/NotificacionesPage";
import DescargarNotas from "../pages/adm/docente/DescargarNotas";
import { DescargarAsistencia } from "../pages/adm/docente/DescargarAsistencia";
import GrupoFiltrarFechasPage from "../pages/adm/grupo/GrupoFiltrarFechasPage";
import GrupoFiltrarPorNota from "../pages/adm/grupo/GrupoFiltrarPorNota";
import { CrearPaisPage } from "../pages/adm/pais/CrearPaisPage";
import { CrearProvinciaPage } from "../pages/adm/provincia/CrearProvinciaPage";
import { PaisPage } from "../pages/adm/pais/PaisPage";
import { ProvinciaPage } from "../pages/adm/provincia/ProvinciaPage";
import { ActualizarPaisPage } from "../pages/adm/pais/ActualizarPaisPage";
import { ActualizarProvinciaPage } from "../pages/adm/provincia/ActualizarProvinciaPage";
import { DepartamentoPage } from "../pages/adm/departamento/DepartamentoPage";
import { CrearDepartamentoPage } from "../pages/adm/departamento/CrearDepartamentoPage";
import { ActualizarDepartamentoPage } from "../pages/adm/departamento/ActualizarDepartamentoPage";
import { CierreGestionPage } from "../pages/adm/mantenimiento/CierreGestionPage";
import { BitacoraAsistencias } from "../pages/adm/asistenciadocente/BitacoraAsistencias";
import { MisAsistencias } from "../pages/doc/asistencia/MisAsistencias";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route
        path="/inicio"
        element={
          <PrivateRoutes roles={["SADM", "ADM", "DOC", "EST"]}>
            <Inicio />
          </PrivateRoutes>
        }
      />
        <Route element={<PrivateRoutes roles={["SADM", "ADM", "DOC"]} />}>
          <Route path="/docentes/descargar-notas" element={<DescargarNotas />} />
          <Route path="/docentes/descargar-asistencia" element={<DescargarAsistencia />} />

        </Route>


      <Route element={<PrivateRoutes roles={["EST"]} />}>
        <Route path="/modulos/:idIdioma" element={<RegistroEstudiantePage />} />
        <Route
          path="/modulos/:idIdioma/detalles"
          element={<RegistroEstudianteDetalle />}
        />
        <Route path="/historial-notas" element={<HistorialNotasPage />} />
        <Route path="/mis-logros" element={<MisLogrosPage />} />
        <Route path="/perfilEstudiante" element={<PerfilEstudiantePage />} />
        <Route path="/perfil/editar" element={<EditarPerfilEstudiantePage />} />

      </Route>

      <Route element={<PrivateRoutes roles={["DOC"]} />}>
        <Route
          path="/idiomas/grupos/:idIdioma"
          element={<GrupoDocentePage />}
        />
        <Route
          path="/idiomas/grupos/:idIdioma/historial"
          element={<HistorialGrupoDocentePage />}
        />
        <Route
          path="/asistencia/iddocente/:idDocente/ididioma/:idIdioma/idgrupo/:idGrupo"
          element={<AsistenciaPage />}
        />
        <Route
          path="/grupos/:idGrupo/registros/:idIdioma/detalles"
          element={<GrupoDocenteDetalle />}
        />

        <Route path="/perfilDocente" element={<PerfilDocentePage />} />
        <Route path="/perfilDocente/editarPerfilDocente" element={<EditarPerfilDocentePage />} />
        <Route path="/mis-asistencias" element={<MisAsistencias />} />
      </Route>

      {/* Rutas compartidas entre estudiantes y docentes */}
      <Route element={<PrivateRoutes roles={["EST", "DOC"]} />}>
        <Route path="/calendario-academico" element={<RecursoEducativo />} />
        <Route path="/malla-curricular" element={<RecursoEducativo />} />
      </Route>

      <Route element={<PrivateRoutes roles={["SADM", "ADM"]} />}>
        <Route path="/perfilAdm" element={<PerfilAdmPage />} />
        <Route path="/perfilAdm/editarPerfilAdm" element={<EditarPerfilAdmPage />} />
        <Route path="/estudiantes" element={<EstudiantePage />} />
        <Route
          path="/estudiantes/registrar"
          element={<RegistrarEstudiantePage />}
        />
        
        <Route
          path="/estudiantes/registro-masivo"
          element={<RegistroMasivoEstudiantesPage />}
        />

        <Route path="/estudiantes/descongelar" element={<DescongelarEstudiantesPage />} />
        <Route path="/docentes/actualizar/:idDocente" element={<ActualizarDocentePage />} />
        <Route path="/estudiantes/actualizar/:idEstudiante" element={<ActualizarEstudiantePage />} />
        <Route path="/estudiantes/congelados" element={<CongeladosPage />} />
        <Route path="/estudiantes/EstudiantesReprobados" element={<EstudiantesReprobadosPage />} />
        <Route path="/estudiantes/activos" element={<EstudiantesActivos />} />
        <Route path="/docentes/plazo-notas" element={<PlazoNotas />} />
        <Route path="/docentes" element={<DocentePage />} />
        <Route path="/docentes/registrar" element={<RegistrarDocentePage />} />
        <Route path="/programas" element={<ProgramaPage />} />
        <Route path="/programas/actualizar/:idPrograma" element={<ActualizarProgramaPage />} />
        <Route path="/programas/gestionar-idiomas" element={<GestionarIdiomasProgramaPage />} />
        <Route path="/programas/registrar" element={<RegistrarProgramaPage />} />
        <Route path="/idiomas" element={<IdiomaPage />} />
        <Route path="/idiomas/registrar" element={<RegistrarIdiomaPage />} />
        <Route path="/idiomas/actualizar/:idIdioma" element={<ActualizarIdiomaPage />} />
        <Route path="/idiomas/modulos/:idIdioma" element={<IdiomaDetalle />} />
        <Route path="/idiomas/VerModulos" element={<ModuloPage />} />
        <Route path="/idiomas/:idIdioma" element={<IdiomaDetalle />} />

        <Route path="/grupos" element={<GrupoPage />} />
        <Route path="/grupos/activos" element={<GruposActivosPage />} />
        <Route path="/grupos/registrar" element={<RegistrarGrupoPage />} />
        <Route path="/grupos/filtrar-fechas" element={<GrupoFiltrarFechasPage />} />
        <Route path="/grupos/filtrar-notas" element={<GrupoFiltrarPorNota />} />
        <Route path="/grupos/actualizar/:idGrupo" element={<ActualizarGrupoPage />} />
        <Route path="/grupos/UnirGrupos/" element={<UnirGruposPage />} />
        <Route path="/grupos/:idGrupo/EstudiantesGrupo" element={<EstudiantesGrupoPage />} />
        <Route path="/turnos" element={<TurnoPage />} />
        <Route path="/modalidades" element={<ModalidadPage />} />
        <Route path="/horarios" element={<HorarioPage />} />
        <Route path="/horarios/registrar" element={<RegistrarHorarioPage />} />
        <Route path="/horarios/actualizar/:idHorario" element={<ActualizarHorarioPage />} />
        <Route path="/modulos/registrar" element={<RegistrarModuloPage />} />
        <Route path="/modulos/actualizar/:idModulo" element={<ActualizarModulo />} />


        <Route path="/asignar-modulo/:idEstudiante" element={<AsignarModuloEstudiantePage />} />
        <Route path="/asignar-modulo-Descongelar/:idEstudiante" element={<AsignarModuloEstudianteDesCongelarPage />} />
        <Route path="/recursos" element={<RecursoEducativo />} />


        <Route path="/notificaciones" element={<NotificacionesPage />} />
        <Route path="/pais" element={<PaisPage />} />
        <Route path="/pais/crear" element={<CrearPaisPage />} />
        <Route path="/pais/actualizar/:idPais" element={<ActualizarPaisPage />} />
        <Route path="/departamento" element={<DepartamentoPage />} />
        <Route path="/departamento/crear" element={<CrearDepartamentoPage />} />
        <Route path="/departamento/actualizar/:idDepartamento" element={<ActualizarDepartamentoPage />} />
        <Route path="/provincia" element={<ProvinciaPage />} />
        <Route path="/provincia/crear" element={<CrearProvinciaPage />} />
        <Route path="/provincia/actualizar/:idProvincia" element={<ActualizarProvinciaPage />} />
        <Route path="/estudiantes/cierre-gestion" element={<CierreGestionPage />} />
        <Route path="/bitacora-asistencias" element={<BitacoraAsistencias />} />
      </Route>

      <Route path="/changepassword" element={<CambiarContrasenaPage />} />

      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};
